import { LogLongTaskInfo } from "./cartxLog";

function getSelectors(path: any) {
  return path
    .reverse()
    .filter((element: any) => {
      return element !== document && element !== window;
    })
    .map((element: any) => {
      let selector = "";
      if (element.id) {
        return `${element.nodeName.toLowerCase()}#${element.id}`;
      } else if (element.className && typeof element.className === "string") {
        return `${element.nodeName.toLowerCase()}.${element.className}`;
      } else {
        selector = element.nodeName.toLowerCase();
      }
      return selector;
    })
    .join(" ");
}

function getPath(pathsOrTarget: any) {
  if (Array.isArray(pathsOrTarget)) {
    return getSelectors(pathsOrTarget);
  } else {
    const path:any = [];
    while (pathsOrTarget) {
      path.push(pathsOrTarget);
      pathsOrTarget = pathsOrTarget.parentNode;
    }
    return getSelectors(path);
  }
}


if (window && !!window.PerformanceObserver) {

  let lastEvent:any = undefined;
  ["click", "touchstart", "mousedown", "keydown", "drop", "dragstart", "dragenter", "dragend"].forEach(
    (eventType: any) => {
      document.addEventListener(
        eventType,
        (event) => {
          lastEvent = event;
        },
        {
          capture: true, // 是在捕获阶段还是冒泡阶段执行
          passive: true, // 默认不阻止默认事件
        }
      );
    }
  );

  new PerformanceObserver((list: any) => {
    list.getEntries().forEach((entry: any) => {
      if (lastEvent && lastEvent.target && entry.duration > 1000) {
        const path: any = getPath(lastEvent.target);
        LogLongTaskInfo({
          duration: entry.duration,
          path: path,
        })
      }
    });
  }).observe({ entryTypes: ["longtask"] });

}
